import {QueryLangFilterOperator} from '../../../enums/query-lang-filter-operator';
import {QueryLangFilterCriterionInput} from '../../../models/filters/query-lang-filter-criterion-input';
import {DexOrderTxFromApi} from '../tx-storage/dex-order-tx';

export class FilterTxByHashInput extends QueryLangFilterCriterionInput {
    public override fieldNames: Array<keyof DexOrderTxFromApi> = ['hash'];
    public placeholder = 'Hash'; // TODO: locale
    public override name = 'filter-tx-by-hash';
    public override operator = QueryLangFilterOperator.EQ;
}
